// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import jQuery from "jquery";
import ModulePreloader from "src/scripts/modules/modulePreloader";
import Registerpage from "src/scripts/pages/registerpage";
import Textpage from "src/scripts/pages/textpage";
import Returnpage from "src/scripts/pages/returnpage";
import Homepage from "src/scripts/pages/homepage";
import ReturnFormPdf from "src/scripts/pages/returnFormPdf";

jQuery(document).ready(function () {
  let pageName = jQuery('body').data('page');

  const modulePreloader = new ModulePreloader();
  modulePreloader.init();

  setTimeout(function () {

    if(pageName == "homepage") {
      const homepage = new Homepage()
      homepage.init();
    }
    else if(pageName == "registerpage") {
      const registerpage = new Registerpage();
      registerpage.init();
    }
    else if(pageName == "returnpage") {
      const returnpage = new Returnpage();
      returnpage.init();
    }
    else if(pageName == "text") {
      const textpage = new Textpage();
      textpage.init();
    }

    // Wire the "Rückgabeformular herunterladen" button wherever it exists
    // (no-op on pages without it).
    new ReturnFormPdf().init();
  }, 100);
});
